<ng-template vdrDialogTitle>{{ "order.import-refund-orders" | translate }}</ng-template>

<p>{{ "order.import-refund-orders-description" | translate }}</p>

<table
  style="
    width: 100%;
    margin-top: 16px;
    border: 1px solid black;
    border-collapse: collapse;
  "
>
  <tr>
    <th
      style="
        text-align: start;
        border: 1px solid black;
        border-collapse: collapse;
      "
    >
      A: {{ "order.refund-excel-date" | translate }}
    </th>
    <th
      style="
        text-align: start;
        border: 1px solid black;
        border-collapse: collapse;
      "
    >
      B: {{ "order.refund-excel-order-code" | translate }}
    </th>
    <th
      style="
        text-align: start;
        border: 1px solid black;
        border-collapse: collapse;
      "
    >
      F: {{ "order.refund-excel-reason" | translate }}
    </th>
  </tr>
  <tbody>
    <tr>
      <td
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        2024-01-01
      </td>
      <td
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        2DG1P7WKA14J36FP
      </td>
      <td
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        {{ "order.refund-reason-customer-request" | translate }}
      </td>
    </tr>
    <tr>
      <td
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        2024-01-02
      </td>
      <td
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        11GN23UAKA14J36FP
      </td>
      <td
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        {{ "order.refund-reason-not-available" | translate }}
      </td>
    </tr>
    ...
  </tbody>
</table>

<div style="margin-top: 2rem; width: 100%">
  <vdr-card *ngIf="fileUpload; else upload">
    {{ fileUpload.name }}
  </vdr-card>

  <ng-template #upload>
    <custom-asset-file-input
      [multiple]="false"
      [acceptTypes]="[
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel'
      ]"
      (selectFiles)="handleFileInput($event)"
    >
    </custom-asset-file-input>
  </ng-template>
</div>

<p style="color: red">{{ error }}</p>

<ng-template vdrDialogButtons>
  <button type="submit" (click)="cancel()" class="btn btn-secondary">
    {{ "common.cancel" | translate }}
  </button>
  <button
    type="submit"
    [disabled]="!fileUpload"
    (click)="import()"
    class="btn btn-primary"
  >
    {{ "common.import" | translate }}
  </button>
</ng-template>
